import { render } from "./MembershipPointTable.vue?vue&type=template&id=5b91b4cd"
import script from "./MembershipPointTable.vue?vue&type=script&lang=js"
export * from "./MembershipPointTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__